import { ChevronDown } from "lucide-react";

export const PictogramCategoryDropdown = ({ id, value, options, onChange, testId, required = false, allowNone = false }) => (
  <div className="min-w-0" data-testid={`${testId}-field`}>
    <label htmlFor={id} className="mb-2 block text-sm font-medium text-[#1A1A1A]"
      data-testid={`${testId}-label`}>Categoria{required ? " *" : ""}</label>
    <div className="relative min-w-0">
      <select id={id} value={value || ""} required={required}
        onChange={event => onChange(event.target.value || null)}
        className={`input-luxury w-full max-w-full min-w-0 appearance-none pr-10 focus-visible:ring-2 focus-visible:ring-[#1A1A1A] focus-visible:ring-offset-1 ${!value ? "product-ux-select-empty" : ""}`}
        data-testid={testId}>
        <option value="" disabled={!allowNone} data-testid={`${testId}-option-empty`}>
          {allowNone ? "— Nessuna categoria —" : "Seleziona una categoria"}
        </option>
        {options.map(option => <option key={option.id} value={option.id}
          data-testid={`${testId}-option-${option.id}`}>{option.label || option.name}</option>)}
      </select>
      <ChevronDown aria-hidden="true" className="pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 text-[#525252]" />
    </div>
  </div>
);